<template>
  <div class="main-content">
    <div class="summary-container">
      <h2 v-if="this.total_modules > 1">Summary</h2>

      <div class="summary-learners" v-if="this.total_modules > 1">
        <p><span>Total learners in this section: </span>{{ total_learners }}</p>
        <p><span>Total modules in this section: </span>{{ total_modules }}</p>
      </div>

      <div class="summary-learners" v-if="this.total_modules === 1">
        <p><span>Total learners in this section: </span>{{ total_learners }}</p>
        <p><span>Average grade: </span>{{ modules_summary[0].module_grade_average }}</p>
      </div>

      <div class="modules_grading" v-if="this.total_modules > 1">
        <h2>Average Grades</h2>
        <table class="modules_grading_table">
          <thead>
            <th>Module</th>
            <th>Average</th>
          </thead>
          <tbody>
            <tr v-for="(module) in modules_summary" :key="module.id">
              <td>{{ module.module_name }}</td>
              <td>{{ module.module_grade_average }}%</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    
    <div class="details-container">
      <h2>Learner Details</h2>
      <div class="details-header">
        <input class="search-input" type="text" placeholder="Search learners" v-model="searchQuery"
          @input="debouncedSearch" />
        <div class="export-csv-container">
          <button class="btn" @click="downloadTableData()">{{ downloadButtonText }}</button>
          <!--<button class="settings-btn">CSV export settings</button>-->
        </div>
      </div>
      <div ref="gradingTable" id="main-data-table"></div>
    </div>
  </div>
</template>

<script>
import dayjs from "dayjs";
import { Tabulator, FilterModule, SortModule, DownloadModule, ExportModule, EditModule, PageModule, AjaxModule} from 'tabulator-tables';
import { utilFunctionService } from "@/utils/utils.service";
import XLSX from "xlsx";
import _ from 'lodash';
window.XLSX = XLSX;
Tabulator.registerModule([FilterModule, SortModule, DownloadModule, ExportModule, EditModule, PageModule, AjaxModule]);

export default {
  name: "Grading-Reporting",
  props: ["section_data"],
  data() {
    return {
      section: '',
      avg_grades: [],
      range: {
        start: new Date(2020, 0, 1),
        end: new Date(2020, 0, 5)
      },
      searchQuery: "",
      date: new Date(),
      course_title: "",
      course_start: "",
      course_end: "",
      total_learners: '',
      total_modules: '',
      total_completed_learners: '',
      total_completed_percent: '',
      users: [],
      modules: [],
      modules_summary: [],
      learners: [],
      columns_data: [],
      tabulator: null,
      tabulatorInitialized: false,
      currentPage: 1,
      totalPages: 1,
      totalRecords: 0,
      pageSize: 20
    };
  },
  created() {
    this.section = JSON.parse(localStorage.getItem("section"));
    utilFunctionService.showLoader();
    this.debouncedSearch = _.debounce(() => {
      if (this.tabulator) {
        this.reloadTable();
      }
    }, 300);
  
    this.initializeData();
  },
  mounted() {
    
    // If data was already loaded but Tabulator wasn't initialized, initialize it now
    if (this.users.length > 0 && !this.tabulatorInitialized) {
      this.$nextTick(() => {
        this.initializeTabulator();
      });
    }
  },
  methods: {
    initializeData() {
      this.users = [];
      this.course_module_grading_details = [];
      
      this.setupColumns();
      this.$nextTick(() => {
        this.initializeTabulator();
      });
      
      utilFunctionService.hideLoader();
    },
    processApiData(data) {
      if (!data || !data.data || !data.data.attributes) {
        console.error("Invalid data format in processApiData", data);
        return;
      }
      
      const attributes = data.data.attributes;
      
      // Process course details
      this.course_title = attributes.course_name || '';
      
      if (attributes.course_start_date) {
        this.course_start = dayjs(attributes.course_start_date).format("dddd, MMMM D, YYYY");
      } else {
        this.course_start = "N/A";
      }
      
      if (attributes.course_end_date) {
        this.course_end = dayjs(attributes.course_end_date).format("dddd, MMMM D, YYYY");
      } else {
        this.course_end = "N/A";
      }

      // Process learner and module data
      this.total_learners = attributes.total_learners_count || 0;
      this.total_completed_learners = attributes.total_learners_completed_all_modules || 0;
      this.total_completed_percent = attributes.percent_learners_finished_all_modules || 0;
      this.total_modules = attributes.total_modules || 0;
      this.modules_summary = attributes.modules_average_grades || [];
      this.users = Array.isArray(attributes.section_learners) ? [...attributes.section_learners] : [];
      
    },
    setupColumns() {
      // Create basic column structure
      this.columns_data = [
        { title: "Name", field: "learner_name", frozen: true },
        { title: "Email", field: "learner_email" },
        { title: "Overall Grade", field: "learner_overall_grade" }
      ];
      
      // Add module columns if there are multiple modules
      if (this.total_modules > 1 && this.users.length > 0) {
        for (let i = 0; i < this.total_modules; i++) {
          // Check if the data structure is as expected
          if (this.users[0].learner_modules_data && 
              this.users[0].learner_modules_data[i] && 
              this.users[0].learner_modules_data[i].attributes) {
            
            const module_name = this.users[0].learner_modules_data[i].attributes.module_name;
            const module_grade = "learner_module_" + (i + 1) + "_grade";
            
            const new_data = {
              title: module_name,
              columns: [
                { title: "Grade", field: module_grade, width: "20%"}
              ]
            };
            
            this.columns_data.push(new_data);
          } else {
            console.error("Invalid module data structure at index", i);
          }
        }
      }
      
    },
    getSelectedModuleId() {
      if (!this.selected_module) return null;
      
      const mod = this.modules.find(elem => elem.attributes.name === this.selected_module);
      return mod ? mod.id : null;
    },
    selectOption(event) {
      this.selected_module = event.target.value;
      
      // Reload the table with the new module selection
      if (this.tabulator) {
        this.tabulator.setData(this.apiUrl, {
          search: this.searchQuery,
          page: 1,
          learn_mod_id: this.getSelectedModuleId()
        });
      }
      
      // Reload course module data if visible
      if (this.isModulesVisible) {
        this.loadCourseModuleData();
      }
    },
    initializeTabulator() {
      // Make sure we have the DOM reference
      if (!this.$refs.gradingTable) {
        console.error("DOM element for Tabulator not found!");
        return;
      }
      
      let accessToken = utilFunctionService.getAuthToken();
      
      // Configure Tabulator options
      const tabulatorOptions = {
        pagination: true,
        paginationMode: "remote",
        paginationSize: this.pageSize,
        paginationSizeSelector: [5, 10, 20, 50],
        paginationInitialPage: 1,
        ajaxURL: this.apiUrl,
        ajaxConfig: {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${accessToken}`,
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token"
          }
        },
        ajaxParams: {
          search: this.searchQuery || '',
          learn_mod_id: this.getSelectedModuleId()
        },
        ajaxResponse: (url, params, response) => {
          // Process the API response to the format Tabulator expects
          
          if (!response.data || !response.data.attributes || !response.data.attributes.section_learners) {
            return {
              data: [],
              last_page: 1,
              total_records: 0
            };
          }
          
          // Store the table headers and metadata for later use
          if (response.data.attributes.lo_table_headers) {
            this.lo_table_headers = response.data.attributes.lo_table_headers;
            this.total_learning_objs = response.data.attributes.total_learning_objs || 0;
            this.total_learners = response.data.attributes.total_learners_count || 0;
            this.reattempts_disabled = !!response.data.attributes.reattempts_disabled;
            this.reattempts_enabled = !this.reattempts_disabled;
            
            // Update columns if needed
            this.setupColumns();
            if (this.tabulator) {
              this.tabulator.setColumns(this.columns_data);
            }
          }
          
          // Update pagination info
          this.currentPage = response.meta.current_page || 1;
          this.totalPages = response.last_page || 1;
          this.totalRecords = response.meta.total_records || 0;
          
          return {
            data: response.data.attributes.section_learners,
            last_page: response.last_page,
            total_records: response.meta.total_records
          };
        },
        autoColumns: false,
        columnHeaderVertAlign: "bottom",
        layout: "fitData",
        layoutColumnsOnNewData: true,
        resizableColumns: true,
        renderHorizontal: "virtual",
        height: "600px",
        persistence: {
          sort: true,
          filter: true,
          columns: true,
        },
        selectable: true,
        sortable: true,
        downloadConfig: {
          columnHeaders: true,
          columnGroups: true,
          rowGroups: false,
          columnCalcs: false,
          dataTree: true
        },
        columns: this.columns_data,
        dataLoaded: () => {
        },
        renderStarted: () => {
        },
        renderComplete: () => {
        }
      };
      
      // Create the Tabulator instance
      this.tabulator = new Tabulator(this.$refs.gradingTable, tabulatorOptions);
      this.tabulatorInitialized = true;
      
      // Add event listeners for debugging
      this.tabulator.on("tableBuilt", () => {
      });
      
      // Handle any errors
      this.tabulator.on("error", (error) => {
        console.error("Tabulator error:", error);
      });
    },
    downloadTableData() {
      if (!this.tabulator) {
        console.error("Tabulator not initialized");
        return;
      }
      
      const spreadsheetName = this.section.attributes.name + " Grading Report Export.xlsx";
      
      // If there's a search query or we want all data, use our custom endpoint
      if (this.searchQuery && this.searchQuery.trim() !== '') {
        // Show loading indicator
        utilFunctionService.showLoader();
        
        // Use custom endpoint to get all data for the search
        fetch(`${process.env.VUE_APP_URL}instructor/v1/sections/${this.section.id}/reports_grading/export_all_data?search=${encodeURIComponent(this.searchQuery)}`, {
          method: 'GET',
          headers: {
            'Authorization': utilFunctionService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.blob())
        .then(blob => {
          // Create a download link and trigger download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = spreadsheetName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          utilFunctionService.hideLoader();
        })
        .catch(error => {
          console.error("Error downloading data:", error);
          utilFunctionService.hideLoader();
          // Fallback to regular download if the custom endpoint fails
          this.tabulator.download("xlsx", spreadsheetName);
        });
      } else {
        // For downloading all data without search filtering
        utilFunctionService.showLoader();
        
        // Use the same endpoint but without search parameter
        fetch(`${process.env.VUE_APP_URL}instructor/v1/sections/${this.section.id}/reports_grading/export_all_data`, {
          method: 'GET',
          headers: {
            'Authorization': utilFunctionService.getAuthToken(),
            'Content-Type': 'application/json'
          }
        })
        .then(response => response.blob())
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.style.display = 'none';
          a.href = url;
          a.download = spreadsheetName;
          document.body.appendChild(a);
          a.click();
          window.URL.revokeObjectURL(url);
          utilFunctionService.hideLoader();
        })
        .catch(error => {
          console.error("Error downloading all data:", error);
          utilFunctionService.hideLoader();
          // Fallback to regular tabulator download
          this.tabulator.download("xlsx", spreadsheetName);
        });
      }
    },
    reloadTable() {
      if (!this.tabulator) return;
      
      // Update the table with the current search query
      this.tabulator.setData(this.apiUrl, {
        search: this.searchQuery,
        page: 1,
        learn_mod_id: this.getSelectedModuleId()
      });
    },
  },
  computed: {
    downloadButtonText() {
      return this.searchQuery && this.searchQuery.trim() !== '' 
        ? `Download Searched Learner Data` 
        : `Download All Learner Data`;
    },
    apiUrl() {
      return `${process.env.VUE_APP_URL}instructor/v1/sections/${this.section.id}/reports_grading/learner_grading_data`;
    }
  },
  watch: {
    users: {
      handler(newVal) {
        // If tabulator is initialized and we have data, update the table
        if (this.tabulator && newVal.length > 0) {
          this.tabulator.setData(newVal);
        }
      },
      deep: true
    }
  }
};
</script>
<style lang="scss" scoped>
@import "tabulator-tables/dist/css/tabulator.css";

.main-content {
  padding: 0;
  width: 100%;
}

.completion-grid {
  width: 100%;
  height: 500px;
  margin-top: 32px;
}

.summary-container {
  margin-bottom: 64px;

  p {
    margin-bottom: 16px;

    span {
      font-weight: bold;
    }
  }

  h2 {
    font-family: 'robotobold', sans-serif;
    font-size: 18px;
    text-transform: capitalize;
  }

  .summary-learners {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 1em;
  }

  .modules_grading {
    padding-top: 3em;

    .modules_grading_table {
      width: 100%;
      padding-top: 1em;
      display: block;

      thead {
        border-bottom: 1px solid #333;

        th {
          padding-bottom: 0.5em;
        }
      }

      tr {
        td {
          padding-right: 1em;
          padding-top: 0.5em;
          width: 20%;
        }
      }
    }
  }

  .summary {
    margin: 2em 0 0 0;

    p {
      margin-bottom: 16px;

      span {
        font-weight: bold;
      }
    }

  }
}

.details-container {
  h2 {
    font-family: 'robotobold', sans-serif;
    font-size: 18px;
    text-transform: capitalize;
  }

  h3 {
    font-size: 16px;
    font-family: 'robotobold', sans-serif;
    text-transform: capitalize;
  }

  .details-header {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: flex-start;
    margin-top: 16px;

    .search-input {
      color: #4a5568;
      height: 45px;
      padding: 0.5rem 0.5rem;
      border-width: 1px;
      border-radius: 0.25rem;
      background-color: #fff;
      margin-left: 16px;
    }
  }

  .export-csv-container {
    display: flex;
    flex-direction: column;
    margin-left: 16px;
  }

  .datePickerBtn {
    color: #3182ce;
    padding: 0.5rem;
    border-width: 1px;
    border-radius: 0.25rem;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    border-color: #bee3f8;
    background-color: #ebf8ff;

    svg {
      fill: currentColor;
      width: 1rem;
      height: 1rem;
    }
  }

  .datePickerInput {
    color: #4a5568;
    padding: 0.5rem 0.5rem;
    border-width: 1px;
    border-radius: 0.25rem;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    background-color: #fff;
  }
}

.export-csv-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  .btn {
    border: 3px solid #3dbc9e;
    background: #fff;
  }

  .settings-btn {
    margin-top: 16px;
    border: none;
    font-weight: bold;
    background: none;
  }
}

.tabulator {
  margin-top: 16px;
  background: #fff;
  white-space: normal !important;

  .tabulator-col-title-holder {
    .tabulator-col-title {
      white-space: normal !important;
    }
  }
}
.grade-convert {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  input {
    margin-right: 4px;
  }

  span {
    margin-left: 16px;

    input {
      width: 75px;
    }
  }
}
</style>
